import React from 'react';
import { Tag as AntTag } from 'antd';

interface IProps {
  src: string;
  color: string;
  text: string;
}

const Tag = ({ src, color, text }: IProps) => (
  <AntTag
    icon={<img src={src} alt="" style={{ marginRight: '5px', marginBottom: '2px' }} />}
    color={`rgba(${color}, 0.1)`}
    style={{
      color: `rgb(${color})`,
      fontSize: '16px',
      fontFamily: 'Robot',
      fontWeight: 600,
      padding: '7px 12px',
      margin: '4px 8px 4px 0',
    }}
  >
    {text}
  </AntTag>
);

export default Tag;
